import React, { FunctionComponent } from 'react';

import useCart from '../../hooks/useCart';
import Alerts from '../../components/Alerts';

const CartAlerts: FunctionComponent = () => {
  const { alerts } = useCart();

  return <Alerts alerts={alerts} />;
};

export default CartAlerts;
